import { styled } from '@material-ui/core/styles';
import { DSTheme } from '../themes/types';

const ImageUpload = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'space-between',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.elevation1,
  padding: '32px',
  marginTop: '8px',
  width: '110px',
  height: '85px',
  outline: 'none',

  '&.image': {
    padding: '16px',
    border: '1px solid',
    borderColor: theme.palette.text.primary,
    width: '142px',
    height: '117px',

    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  '&.dashed': {
    border: '1px dashed',
    borderColor: theme.palette.text.primary,
  },
}));

export default ImageUpload;
